import { useEffect, useRef, useState } from 'react';

export const useInView = (threshold = 0.25) => {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setSeen(true); io.disconnect(); } }, { threshold });
    io.observe(el);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, seen];
};

export const Reveal = ({ children, delay = 0, className = '', as: Tag = 'div', ...rest }) => {
  const [ref, seen] = useInView(0.2);
  return (
    <Tag ref={ref} style={{ transitionDelay: `${delay}ms` }} {...rest}
      className={`transition-[opacity,transform] duration-[1200ms] ease-out ${seen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} ${className}`}>
      {children}
    </Tag>
  );
};
